import { useEffect } from "react";

const SITE = "ThemeStudios — Premium 3D Motion Graphics Studio";
const DEFAULT_OG = "https://themestudios.in/assets/portfolio/business-portfolio-2026.webp";

/**
 * Lightweight page meta updater (no react-helmet dependency).
 * Updates <title>, description, canonical, OG and Twitter tags per route.
 */
export default function usePageMeta({ title, description, path = "/", image = DEFAULT_OG }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ThemeStudios` : SITE;
    document.title = fullTitle;

    const setTag = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(selector.startsWith("link") ? "link" : "meta");
        // populate selector attribute on element
        const match = selector.match(/\[(.+?)="(.+?)"\]/);
        if (match) el.setAttribute(match[1], match[2]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    const desc =
      description ||
      "ThemeStudios — Madurai-based digital design studio. Posters, reels, branding, ads & monthly creative systems for Indian small businesses. ₹349 to ₹29,999.";

    const url = `https://themestudios.in${path}`;

    setTag('meta[name="description"]', "content", desc);
    setTag('link[rel="canonical"]', "href", url);

    setTag('meta[property="og:type"]', "content", "website");
    setTag('meta[property="og:title"]', "content", fullTitle);
    setTag('meta[property="og:description"]', "content", desc);
    setTag('meta[property="og:url"]', "content", url);
    setTag('meta[property="og:image"]', "content", image);
    setTag('meta[property="og:site_name"]', "content", "ThemeStudios");

    setTag('meta[name="twitter:card"]', "content", "summary_large_image");
    setTag('meta[name="twitter:title"]', "content", fullTitle);
    setTag('meta[name="twitter:description"]', "content", desc);
    setTag('meta[name="twitter:image"]', "content", image);
  }, [title, description, path, image]);
}
